import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi,baseURL} from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { message } from "antd";

class MachineryReportStore {
  machineryReport = [];
  emailIdsList=[]
  remaning_vehicleId = ""
  last_record_timestamp = ""
  total = 0;
  loading = false;
  rootStore;
  pythonReportMessage=false

  constructor(rootStore) {
    makeObservable(this, {
      machineryReport: observable,
      total: observable,
      loading: observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      loadData: action,
      exportcsv:action,
      exportExcel:action,
      exportpdf:action,
      exportxml:action,

      pythonReportMessage:observable,

      // getEmailIds:action
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId,offset, limit, vehicleId, fromDate, toDate,pageNo}) {
    this.loading = true;
    console.log("Machinery Report ");

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if(config.pythonReport === 1){
      // postData.companyId=10166
      // postData.vehicleId=[26375]
        if(offset === 0){
          postData.last_record_timestamp = ""
          postData.remaning_vehicleId = ""
        }else{
          postData.last_record_timestamp = this.last_record_timestamp
          postData.remaning_vehicleId = this.remaning_vehicleId
        }
        var response = await postApi.getClient('report').post("/report/machineryReport", postData);
        this.total = 500

    }else{

        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi.getClient().post("index.php?c=vehicle&a=machineryReport", "postData=" + base64Input);
    }
    // console.log("Machinery", response?.data?.data?.workinghour);

    // console.log("company Data",response?.data?.data?.workinghour)
    if(config.pythonReport === 1){
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    }
    
    this.machineryReport = response?.data?.data?.workinghour;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }

  // async getEmailIds({companyId}) {
  //   console.log("companyId", companyId)
  //   var postData = {"companyId":companyId}
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi.getClient().post("index.php?c=vehicle&a=getEmailIds", "postData=" + base64Input);
  //   console.log(response, "post")
  
  //   this.emailIdsList = response?.data?.data
  //   return response?.data?.data
  // }

  async exportExcel(getData) {
    // console.log("getData", getData);
    let lang = "english";
    if(config.pythonReport === 1){

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {
  
          const res =   await postApi.getClient("report").post("/report/machineryReport/download/excel", getData, {
              responseType: "blob",
          });

          this.pythonReportMessage=true;
          // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
         
      } catch (error) {
          this.pythonReportErrorMessage=true;
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportMachineryExcel&cid=" +
          getData.companyId +
          "&vid=" +
          getData.vehicleId +
          "&userId="+
          getData.userId+
          "&int=" +
        0 +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportGensetWorkingHourcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&userId="+
      getData.userId+
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {
        // await message.success("fnv")
        // console.log("object",this.pythonReportMessage)
          await postApi.getClient("report").post("/report/machineryReport/download/pdf", getData, {
              responseType: "blob",
          });
          this.pythonReportMessage=true;
          //await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
        
      } catch (error) {
        this.pythonReportErrorMessage=true;
          message.error("Failed to download the report. Please try again.")
      }
      
    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportMachineryPdf&cid=" +
          getData.companyId +
          "&vid=" +
          getData.vehicleId +
          "&int=" +
          getData.interval +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&userId="+
          getData.userId+
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }
  }

  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportexidlexml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  // async sendExcelByEmail(data) {
  //   var postData = data;
  //   console.log(postData);
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=vehicle&a=exportstartstopexcel",
  //       "postData=" + base64Input
  //     );
  //   console.log(response);

  //   return response.data;
  // }
}

export default MachineryReportStore;
